import PropTypes from 'prop-types';
import Dynamic from 'next/dynamic';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Typography,
} from '@mui/material';
import ReactHtmlParser from 'react-html-parser';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useScholarship } from 'providers/ScholarshipProvider';

import { handleSuccessButton } from 'utils/planUtils';

const SuccessButtonComponent = Dynamic(
  () => import('components/Buttons/SuccessButtonComponent'),
  { ssr: false }
);

DynamicFaqComponent.propTypes = {
  dynamicFaqText: PropTypes.string.isRequired,
  dynamicFaqTopics: PropTypes.instanceOf(Array).isRequired,
  showButton: PropTypes.bool,
};

DynamicFaqComponent.defaultProps = {
  showButton: true,
};

export default function DynamicFaqComponent({
  dynamicFaqText,
  dynamicFaqTopics,
  showButton,
}) {
  const isScholarship = useScholarship();

  return (
    <Container id="faq" maxWidth="lg">
      <Typography
        component="h2"
        sx={{ fontWeight: 800, margin: '64px auto', textAlign: 'center' }}
        variant="h4"
      >
        {dynamicFaqText}
      </Typography>

      <Box textAlign="left">
        {dynamicFaqTopics?.map(({ question, answer }, index) => (
          <Accordion key={`faq-${index}`}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="faq-content"
              id={`faq-${index}`}
            >
              <Typography component="h3" variant="subtitle1">
                {question}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ width: '100%' }}>
              {ReactHtmlParser(answer?.html)}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box textAlign="center" py={showButton ? 8 : 4}>
        {showButton && (
          <SuccessButtonComponent
            id="faq-to-plans"
            onClick={handleSuccessButton}
            size="large"
            variant="contained"
          >
            {isScholarship ? 'Ativar bolsa' : 'Quero Assinar'}
          </SuccessButtonComponent>
        )}
      </Box>
    </Container>
  );
}
